import React from 'react';
export function Footer() {
  return <footer className="bg-[#E5D6BC] py-10 px-3 border-t border-ink/10" data-id="element-71">
      <div className="max-w-4xl mx-auto text-center space-y-4" data-id="element-72">
        <p className="font-display text-base text-accent font-bold" data-id="element-73">
          MegaPack Inclusión Lista™
        </p>
        <p className="text-xs text-muted/70" data-id="element-74">
          © MegaPack Inclusión Lista™ 2026 — Todos los derechos reservados.
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}